import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Icon from '../components/Icon'
import { Helmet } from 'react-helmet-async'

const SECTIONS = [
  { h: '1. The short version', p: 'We only use your files to perform the task you asked for. In fact, your files never leave your device everything runs locally in your browser and nothing is uploaded to a server.' },
  { h: '2. Files you use', p: 'When you use a tool, your file is processed right in the page to produce the result you requested. It is never sent anywhere, and it is cleared the moment you leave or refresh the page.' },
  { h: '3. Information we collect', list: ['Basic, anonymous usage data (such as which tool was opened) to keep the service reliable.', 'Standard technical details your browser sends, like device type, used only for security and performance.'], p: 'We do not require an account, and we do not ask for personal details to use the tools.' },
  { h: '4. Cookies', p: "We use a small number of essential cookies to make the site work and to remember basic preferences. We don't use cookies to build advertising profiles." },
  { h: '5. Sharing', p: "We don't sell your data. Because processing happens on your device, there is nothing to share in the first place." },
  { h: '6. Your choices', p: 'You can stop using the tools at any time and clear your files instantly by closing the tab. For questions about your data, reach us through the contact page.' },
  { h: '7. Changes', p: "If this policy changes, we'll update the date above. Significant changes will be highlighted on the site." },
]

function Privacy() {
  const navigate = useNavigate()
  useEffect(() => window.scrollTo(0, 0), [])

  return (
    <>
    <Helmet>
        <title>Privacy Policy | iLoveImgPdf</title>

        <meta
          name="description"
          content="iLoveImgPdf free online image & PDF tools. Compress, resize, crop, convert, merge, split, edit, sign and unlock your files right in the browser."
        />

        <meta
          name="keywords"
          content="Image,image tools, pdf tools, compress image, resize image, crop image, convert image, remove background, image to pdf, merge pdf, split pdf, compress pdf, pdf to word, word to pdf, pdf to excel, pdf to ppt, pdf to jpg, edit pdf, sign pdf, unlock pdf, protect pdf, rotate pdf, watermark pdf, free online tools"
        />

        <link
          rel="canonical"
          href="https://iloveimgpdf.com/privacy"
        />
      </Helmet>
    <main className="view">
      <div className="wrap subpage">
        <div className="doc-page">
          {/* <div className="crumbs">
            <a onClick={() => navigate('/')}>Home</a>
            <Icon name="chevron-right" size={15} />
            <span className="here">Privacy Policy</span>
          </div> */}
          <div className="doc-head">
            <h1 className="" style={{marginBottom: '25px',textAlign: 'center' ,color:"#4338ca"}}>Privacy Policy</h1>
            {/* <h2 >Your files stay yours.</h2> */}
            {/* <div className="doc-meta">Last updated: 1 June 2026 · This is a sample policy to adapt for your own use.</div> */}
          </div>
          <div className="doc-body">
            <p className="privacy">This policy explains, in plain language, what iLoveImgPdf does with your files and information when you use the tools.</p>
            {SECTIONS.map((s, i) => (
              <div className="doc-section" key={i}>
                <h2>{s.h}</h2>
                {s.list && (
                  <ul>
                    {s.list.map((li, j) => <li key={j}>{li}</li>)}
                  </ul>
                )}
                {s.p && <p>{s.p}</p>}
              </div>
            ))}
            <div className="doc-section">
              <h2>8. Contact</h2>
              <p>
                Questions about privacy or your data? Reach us any time through the{' '}
                <span className="lnk" onClick={() => navigate('/contact')} style={{ color: 'var(--brand-600)', fontWeight: 600, cursor: 'pointer' }}>
                  Contact page →
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
    </>
  )
}

export default Privacy
